/**
 * Product Collection block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS.
 * The card's own stylesheet is a separate bundle, wired by the `slate.uses`
 * declaration in block.json — see inc/assets.php.
 *
 * The only behaviour is the entrance: the section sits below the fold, so a
 * plain CSS animation would have played out before anyone scrolled to it.
 */

import './index.scss';

const sections = document.querySelectorAll('.product-collection');

if (sections.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.setAttribute('data-reveal', 'in');
                    observer.unobserve(entry.target);
                }
            }
        },
        { rootMargin: '0px 0px -15% 0px' }
    );

    for (const section of sections) {
        section.setAttribute('data-reveal', 'pending');
        observer.observe(section);
    }
}
